export const POST_LOGIN_REQUESTED = 'POST_LOGIN_REQUESTED'
export const POST_LOGIN_REQUEST_FAILED = 'POST_LOGIN_REQUEST_FAILED'
export const POST_LOGIN_REQUEST_SUCCESSED = 'POST_LOGIN_REQUEST_SUCCESSED'
export const POST_LOGIN_TERMS_NOT_ACCEPTED = 'POST_LOGIN_TERMS_NOT_ACCEPTED'
export const POST_ADMIN_LOGIN_REQUESTED = 'POST_ADMIN_LOGIN_REQUESTED'
export const POST_ADMIN_LOGIN_REQUEST_FAILED = 'POST_ADMIN_LOGIN_REQUEST_FAILED'
export const POST_ADMIN_LOGIN_REQUEST_SUCCEEDED = 'POST_ADMIN_LOGIN_REQUEST_SUCCEEDED'
export const POST_UPDATE_PASSWORD_REQUESTED = 'POST_UPDATE_PASSWORD_REQUESTED'
export const POST_UPDATE_PASSWORD_SUCCESSED = 'POST_UPDATE_PASSWORD_SUCCESSED'
export const POST_UPDATE_PASSWORD_FAILED = 'POST_UPDATE_PASSWORD_FAILED'
export const CLOSE_RESET_PASSWORD_MODAL = 'CLOSE_RESET_PASSWORD_MODAL'
export const SET_ACCOUNTS_SELECTED = 'SET_ACCOUNTS_SELECTED'
export const SET_CLIENTS_SELECTED = 'SET_CLIENTS_SELECTED'
export const UPDATE_ACCOUNT_SELECTION = 'UPDATE_ACCOUNT_SELECTION'
export const UPDATE_ACCOUNT_SELECTION_SUCCEEDED = 'UPDATE_ACCOUNT_SELECTION_SUCCEEDED'
export const SEND_RESET_PASSWORD_EMAIL_REQUESTED = 'SEND_RESET_PASSWORD_EMAIL_REQUESTED'
export const SEND_RESET_PASSWORD_EMAIL_SUCCESSED = 'SEND_RESET_PASSWORD_EMAIL_SUCCESSED'
export const SEND_RESET_PASSWORD_EMAIL_FAILED = 'SEND_RESET_PASSWORD_EMAIL_FAILED'
export const TOGGLE_I2_AND_QS_TOOL_USER_MODAL = 'TOGGLE_I2_AND_QS_TOOL_USER_MODAL'
